module.exports = __webpack_public_path__ + "static/media/car.47f1a370.svg";